export default {
  refund: {
    id: 'asp_seller_action_bar_actions_list_step_refund_action',
    defaultMessage: 'Refund',
  },
  shipBackToCustomer: {
    id: 'asp_action_bar_ship_back_item_step_action',
    defaultMessage: 'Repair, replace, or return',
  },
  reportProblem: {
    id: 'asp_action_bar_actions_list_declare_problem_action',
    defaultMessage: 'Report a problem',
  },
  refundCustomerBlockedTooltip: {
    id: 'asp_seller_action_bar_actions_list_step_refund_customer_blocked_tooltip',
    defaultMessage: 'Refunds are blocked during fraud investigation.',
  },
}
